import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

import Footer from "../../components/Footer";
import DFNavbar from "../../components/Navbar";
import dfbird_icon from "./../../img/dfbird/icon.png";
import dfbird_screen from "./../../img/dfbird/screen.png";
import dfbird_automation from "./../../img/dfbird/automation.png";
import dfbird_calc_area from "./../../img/dfbird/calc-area.png";
import dfbird_calc_distance from "./../../img/dfbird/calc-distance.png";

import { ScrollToTop } from "../../components/ScrollToTop";
import { DOWNLOAD_ROUTE } from "../../consts/routes";
import { Helmet } from "react-helmet";
import i18n from "../../i18n/configs";

/**
 * DF BIRD詳細画面
 * @returns JSX.Element
 */
const DetailDfbird = () => {
    const { t } = useTranslation();

    return (
        <div className="flex min-h-screen flex-col">
            <Helmet>
                <title>{t("DetailDfbird.meta.title")}</title>
                <meta name="description" content={t("DetailDfbird.meta.description")} />
            </Helmet>
            <ScrollToTop />
            <DFNavbar bottomPadding={true} />
            <div className="flex-grow items-center justify-center px-6 py-8 pt-20 lg:px-20">
                <div className="mx-auto max-w-screen-md px-4 md:px-8">
                    <div className="flex items-center justify-center">
                        <img className="h-20 w-20 p-3" src={dfbird_icon} alt="dflat" />
                        <h1 className="text-center text-2xl font-bold text-gray-800 sm:text-3xl ">DF BIRD</h1>
                    </div>
                </div>

                <div className="mx-auto mt-10 flex max-w-3xl items-center justify-center">
                    {i18n.language === "ja"
                        ? "「DF BIRD」詳細ページは移行しました。"
                        : "The 'DF BIRD' details page has been moved."}
                </div>
                <div className="mx-auto flex max-w-3xl items-center justify-center">
                    <a
                        href={
                            i18n.language === "ja"
                                ? "https://deepforest-tech.co.jp/df-bird/"
                                : "https://deepforest-tech.co.jp/en/df-bird/"
                        }
                        className="link-text mt-4 text-sm font-bold"
                    >
                        {i18n.language === "ja" ? "新しいページへ移動する" : "Go to the new page."}
                    </a>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default DetailDfbird;
